/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ng2-translate/src/translate.pipe';
import * as import2 from 'ng2-translate/src/translate.service';
import * as import3 from '../../buttons/link/link.component.ngfactory';
import * as import4 from '../../buttons/link/link.component';
import * as import5 from '../../html-utils/html.pipe';
import * as import6 from '@angular/platform-browser';
import * as import7 from '@angular/common';
import * as import8 from './legal-panel.component';
import * as import9 from '../../orchestration/analytics.service';
import * as import10 from '../../orchestration/navigation.service';
const styles_LegalPanelComponent:any[] = ([] as any[]);
export const RenderType_LegalPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_LegalPanelComponent,
  data: {}
}
);
function View_LegalPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'legal-text'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,2,0,import0.ɵnov((<any>v.parent),0),import0.ɵunv(v,0,0,import0.ɵnov(v,1).transform((('woa.message.' + co.messageSet) + '.legal.pre'),co.messageParams))));
    ck(v,0,0,currVal_0);
  });
}
function View_LegalPanelComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.feedback()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_LinkComponent_0,import3.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import4.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    const currVal_0:any = 'woa.label.legal.feedback';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_LegalPanelComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'legal-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform((('woa.message.' + co.messageSet) + '.legal.conjunction')));
    ck(v,1,0,currVal_0);
  });
}
function View_LegalPanelComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'legal-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform((('woa.message.' + co.messageSet) + '.legal.post')));
    ck(v,1,0,currVal_0);
  });
}
export function View_LegalPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import5.HtmlPipe,[import6.DomSanitizer]),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LegalPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import7.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LegalPanelComponent_2)),
    import0.ɵdid(16384,(null as any),0,import7.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LegalPanelComponent_3)),
    import0.ɵdid(16384,(null as any),0,import7.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import8.LegalPanelComponent = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.showAdminDetails('terms')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_LinkComponent_0,import3.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import4.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'}),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'legal-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import8.LegalPanelComponent = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.showAdminDetails('privacy')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_LinkComponent_0,import3.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import4.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LegalPanelComponent_4)),
    import0.ɵdid(16384,(null as any),0,import7.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import8.LegalPanelComponent = v.component;
    const currVal_0:boolean = !co.showFeedback;
    ck(v,2,0,currVal_0);
    const currVal_1:any = co.showFeedback;
    ck(v,4,0,currVal_1);
    const currVal_2:any = co.showFeedback;
    ck(v,6,0,currVal_2);
    const currVal_3:any = 'woa.label.legal.terms';
    ck(v,8,0,currVal_3);
    const currVal_5:any = 'woa.label.legal.privacy';
    ck(v,13,0,currVal_5);
    const currVal_6:boolean = !co.showFeedback;
    ck(v,15,0,currVal_6);
  },(ck,v) => {
    var co:import8.LegalPanelComponent = v.component;
    const currVal_4:any = import0.ɵunv(v,10,0,import0.ɵnov(v,11).transform((('woa.message.' + co.messageSet) + '.legal.conjunction')));
    ck(v,10,0,currVal_4);
  });
}
function View_LegalPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-legal-panel',([] as any[]),(null as any),(null as any),(null as any),View_LegalPanelComponent_0,RenderType_LegalPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import8.LegalPanelComponent,[
      import9.AnalyticsService,
      import10.NavigationService
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const LegalPanelComponentNgFactory:import0.ComponentFactory<import8.LegalPanelComponent> = import0.ɵccf('woa-legal-panel',import8.LegalPanelComponent,View_LegalPanelComponent_Host_0,{
  messageSet: 'messageSet',
  messageParams: 'messageParams',
  showFeedback: 'showFeedback'
}
,{onLinkOpened: 'onLinkOpened'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/legal/legal-panel/legal-panel.component.ngfactory.ts